import { Clickable, Col, Icon, Row, Text } from 'components';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { ChartModal } from './';

const DashboardItem = ({
  bg,
  title,
  small,
  big,
  valueTitle1,
  value1Type = 'decimal',
  valueTitle2,
  data,
  value2Prefix,
  dark,
  paymentHistory,
  type
}) => {
  const [visible, setVisible] = useState(false),
    user = useSelector((state) => state.user);

  function handleVisible() {
    setVisible(!visible);
  }

  function getHeight() {
    if (small) return 100;
    if (big) return 120;
    return 110;
  }

  return (
    <Col wid="100%">
      <Text h2>{title}</Text>

      <Col
        marg="8px 0 0"
        ht={`${getHeight() - 32}px`}
        noFlex
        between
        wid="calc(100% - 32px)"
        bg={bg}
        pad="16px"
      >
        <Row wid="100%" between>
          <Row between wid="100%">
            <Col>
              <Text b1 col={dark ? '#fff' : '#000'}>
                {valueTitle1}
              </Text>

              <Text h1 col={dark ? '#fff' : '#000'}>
                {(data?.total || 0).toLocaleString(undefined, {
                  style: value1Type,
                  currency: user.billing?.currency || 'usd',
                  maximumSignificantDigits: 2
                })}
              </Text>
            </Col>

            <Col>
              <Text b1 col={dark ? '#fff' : '#000'}>
                {valueTitle2}
              </Text>

              <Text h1 col={dark ? '#fff' : '#000'}>
                {value2Prefix}
                {(data
                  ? data.type === 'referral'
                    ? data.users
                    : data.count
                  : 0
                )?.toLocaleString()}
              </Text>
            </Col>
          </Row>

          <Clickable onClick={handleVisible}>
            <Icon type="barChart" dimensions={14} col={dark ? '#fff' : '#000'} />
          </Clickable>
        </Row>
      </Col>

      <ChartModal
        visible={visible}
        closeModal={handleVisible}
        paymentHistory={paymentHistory}
        title={title}
        valueTitle1={valueTitle1}
        valueTitle2={valueTitle2}
        type={type}
      />
    </Col>
  );
};

export default DashboardItem;
